import clsx from 'clsx'
import {FocusEventHandler} from 'react'
import {GroupBase, components} from 'react-select'
import {AsyncPaginate} from 'react-select-async-paginate'
import {GymOutletOption, loadGymOutletOptions} from '../core/outletOptions'

type Props = {
  value: GymOutletOption | null
  onChange: (outlet: GymOutletOption | null) => void
  onBlur: FocusEventHandler<HTMLInputElement>
  isClearable: boolean
  isDisabled: boolean
}

const initialPage = {page: 1}

export function GymOutletSelect({value, onChange, onBlur, isClearable, isDisabled}: Props) {
  return (
    <AsyncPaginate<GymOutletOption, GroupBase<GymOutletOption>, {page: number}, false>
      inputId='gym-outlet'
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      loadOptions={loadGymOutletOptions}
      additional={initialPage}
      defaultOptions
      debounceTimeout={1000}
      isSearchable
      isClearable={isClearable}
      isDisabled={isDisabled}
      placeholder={
        <span className='custom-dropdown-placeholder fw-semibold'>Cari dan pilih outlet</span>
      }
      noOptionsMessage={() => 'Outlet tidak ditemukan'}
      styles={{
        control: (provided) => ({...provided, borderRadius: 6, background: 'transparent'}),
        option: (provided) => ({...provided, fontSize: 13}),
        input: (provided) => ({...provided, textAlign: 'center'}),
        indicatorsContainer: (provided) => ({
          ...provided,
          position: 'absolute',
          right: 0,
          top: 0,
          bottom: 0,
          marginTop: 3,
          display: 'flex',
        }),
      }}
      components={{
        IndicatorSeparator: null,
        Control: (props) => (
          <components.Control
            {...props}
            className={clsx(props.className, 'form-select py-2 px-1')}
          />
        ),
        SelectContainer: (props) => (
          <components.SelectContainer {...props} className={clsx(props.className, 'border-0')} />
        ),
        Input: (props) => <components.Input {...props} className='py-0' />,
        ValueContainer: (props) => (
          <components.ValueContainer {...props} className={clsx(props.className, 'fw-bold')} />
        ),
      }}
    />
  )
}
